import { observable, action } from 'mobx';
import config from 'config';
import HttpClient from 'utils/httpclient';
import { LOADING, LOADED } from 'stores/BaseStore';
import Moment from 'moment-timezone';

class ReportsAllocationsStore {
  @observable data = null;
  @observable status = LOADED;

  @action getAllAllocations (searcParams) {
    this.status = LOADING;
    let params = Object.assign({},searcParams);
    params.siteId = this.getCurrentSiteID();
    params.startDate = Moment(searcParams.startDate).format('YYYY-MM-DD');
    params.endDate = Moment(searcParams.endDate).format('YYYY-MM-DD');

    return HttpClient.get(`${config.api}/reports/allocation`, { params })
      .then(response => {
        this.data = response.data;
        return response;
      }).finally(() => this.status = LOADED);
  }

  @action reset () {
    this.data = null;
    this.status = LOADED;
  }

  @action getCurrentSiteID () {
    let site = JSON.parse(localStorage.getItem('site'));
    return site ? site.id : null;
  }
  @action getAllocation(id){
    this.status = LOADING;
    return HttpClient.get(`${config.api}/reports/allocation/${id}`)
      .then(response => {
        this.status = LOADED
        return response.data;
      });
  }
}

export default new ReportsAllocationsStore();
